import React, { lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const BillingInfoProducerContainer = lazy(
  () =>
    import(
      '@pages/producer/BillingInfoProducer/components/BillingInfoContainer'
    ),
);
const BillingInfoProducer = lazy(
  () => import('@pages/producer/BillingInfoProducer'),
);
const PaymentSucceeded = lazy(
  () =>
    import('@pages/producer/BillingInfoProducer/components/PaymentSucceeded'),
);
const PaymentFailed = lazy(
  () => import('@pages/producer/BillingInfoProducer/components/PaymentFailed'),
);
export const BillingInfoProducerRoutes: RouteObject[] = [
  {
    path: '/billing-info-producer',
    element: (
      <React.Suspense>
        <BillingInfoProducer />
      </React.Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <React.Suspense>
            <BillingInfoProducerContainer />
          </React.Suspense>
        ),
      },
      {
        path: 'success',
        element: (
          <React.Suspense>
            <PaymentSucceeded />
          </React.Suspense>
        ),
      },
      {
        path: 'cancel',
        element: (
          <React.Suspense>
            <PaymentFailed />
          </React.Suspense>
        ),
      },
    ],
  },
];
